import { defineComponent as v, computed as n, provide as y, openBlock as o, createElementBlock as i, normalizeClass as s, unref as r, createElementVNode as w, createTextVNode as p, toDisplayString as c, createCommentVNode as f, renderSlot as b } from "vue";
import { c as u } from "./cn-Bje3WtSp.js";
import { u as B } from "./useId-DuhnX31i.js";
import { F as g } from "./formFieldContext-OfRFoILA.js";
const k = ["for"], F = {
  key: 0,
  class: "text-danger",
  "aria-hidden": "true"
}, T = ["id"], V = /* @__PURE__ */ v({
  __name: "FormField",
  props: {
    label: {},
    helperText: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    hideLabel: { type: Boolean, default: !1 },
    width: { default: "md" },
    id: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, l = B("kori-field", t.id), a = n(() => t.helperText || t.error ? `${l.value}-helper` : void 0), m = n(() => !!t.error);
    let d = !1;
    y(g, {
      id: l,
      describedBy: a,
      invalid: m,
      claim: () => d ? !1 : d = !0,
      release: () => {
        d = !1;
      }
    });
    const x = {
      xs: "max-w-[8rem]",
      sm: "max-w-[12rem]",
      md: "max-w-[20rem]",
      lg: "max-w-[28rem]",
      xl: "max-w-[36rem]",
      full: "w-full"
    };
    return (h, C) => (o(), i("div", {
      class: s(r(u)("flex flex-col gap-1", x[e.width], t.class))
    }, [
      w("label", {
        for: r(l),
        class: s(e.hideLabel ? "sr-only" : "text-sm font-medium text-text-primary")
      }, [
        p(c(e.label) + " ", 1),
        e.required ? (o(), i("span", F, "*")) : f("", !0)
      ], 10, k),
      b(h.$slots, "default", {
        id: r(l),
        describedBy: a.value,
        invalid: m.value
      }),
      e.error || e.helperText ? (o(), i("p", {
        key: 0,
        id: a.value,
        class: s(r(u)("text-xs", e.error ? "text-danger" : "text-text-secondary"))
      }, c(e.error || e.helperText), 11, T)) : f("", !0)
    ], 2));
  }
});
export {
  V as _
};
//# sourceMappingURL=FormField.vue_vue_type_script_setup_true_lang-yz8eNX74.js.map
